/* Product page sliders: same-category products + recently viewed (Lady by Design) */
(function () {
  if (window.__aiPdpSliders) return;
  window.__aiPdpSliders = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var KEY = 'ldb_recently_viewed';
  var MAX_STORED = 20;

  /* Product types that belong to the same category. The product's own type is shown first;
     the rest of its group only fills up the slider if that type has too few products. */
  var GROUPS = [
    ['Coats for Women', 'Coat', 'Puffer Jackets for Women', 'Leather Jackets for Women', 'Jacket', "Women's Jacket", 'Blazers for Women'],
    ['Boots for Women', 'Loafers for Women', 'Heels for Women'],
    ['Sweaters for Women', 'Sweater', 'Pullover', 'Cardigans for Women', 'Cardigan', 'Hoodie'],
    ['Midi Dresses for Women', 'Maxi Dresses for Women', 'Mini Dresses for Women', 'Dresses for Women', 'Sweater Dresses for Women'],
    ['Blouses for Women', 'Tops for Women', 'T-Shirts for Women'],
    ['Pants for Women', 'Jeans for Women', 'Jeans', 'Leggings', 'Sweatpants', 'Skirts for Women'],
    ['Sets for Women', 'Set', 'Two-piece set', 'Summer Sets for Women', 'Jogging Sets for Women', 'Loungewear Sets for Women', 'Tracksuits for Women', 'Pajama set'],
    ['Bags for Women', 'Bag', 'Shoulder bag']
  ];

  function typesFor(type) {
    var list = [type];
    GROUPS.forEach(function (g) {
      if (g.indexOf(type) > -1) g.forEach(function (t) { if (list.indexOf(t) < 0) list.push(t); });
    });
    return list;
  }

  function fetchCards(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return [];
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        return Array.prototype.slice.call(tmp.querySelectorAll('.ai-feed__item'));
      })
      .catch(function () { return []; });
  }

  function addCards(track, items) {
    items.forEach(function (item) {
      var li = document.createElement('li');
      li.className = 'ai-rs__item';
      li.setAttribute('data-handle', item.getAttribute('data-handle'));
      while (item.firstChild) li.appendChild(item.firstChild);
      track.appendChild(li);
    });
  }

  /* ---------- slider controls: arrows + draggable scrollbar ---------- */
  function initSlider(root) {
    var track = root.querySelector('.ai-rs__track');
    var prev = root.querySelector('.ai-rs__arrow--prev');
    var next = root.querySelector('.ai-rs__arrow--next');
    var bar = root.querySelector('.ai-rs__bar');
    var thumb = root.querySelector('.ai-rs__thumb');
    if (!track) return;

    function step() {
      var first = track.querySelector('.ai-rs__item');
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var per = Math.max(1, Math.floor((track.clientWidth + gap) / (first.offsetWidth + gap)));
      return per * (first.offsetWidth + gap);
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var scrollable = max > 2;
      root.classList.toggle('is-static', !scrollable);
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      if (thumb && bar) {
        var ratio = track.clientWidth / track.scrollWidth;
        var w = Math.max(ratio * bar.clientWidth, 40);
        thumb.style.width = w + 'px';
        var pos = max > 0 ? (track.scrollLeft / max) * (bar.clientWidth - w) : 0;
        thumb.style.transform = 'translateX(' + pos + 'px)';
      }
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    if (bar && thumb) {
      var dragging = false, startX = 0, startLeft = 0;
      thumb.addEventListener('pointerdown', function (e) {
        dragging = true; startX = e.clientX; startLeft = track.scrollLeft;
        thumb.setPointerCapture(e.pointerId); root.classList.add('is-dragging'); e.preventDefault();
      });
      thumb.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var max = track.scrollWidth - track.clientWidth;
        var room = bar.clientWidth - thumb.offsetWidth;
        if (room <= 0) return;
        track.scrollLeft = startLeft + (e.clientX - startX) * (max / room);
      });
      function stop() { dragging = false; root.classList.remove('is-dragging'); }
      thumb.addEventListener('pointerup', stop);
      thumb.addEventListener('pointercancel', stop);
      bar.addEventListener('pointerdown', function (e) {
        if (e.target === thumb) return;
        var rect = bar.getBoundingClientRect();
        var max = track.scrollWidth - track.clientWidth;
        var frac = (e.clientX - rect.left - thumb.offsetWidth / 2) / (rect.width - thumb.offsetWidth);
        track.scrollTo({ left: Math.min(1, Math.max(0, frac)) * max, behavior: 'smooth' });
      });
    }
    track.querySelectorAll('img').forEach(function (img) { if (!img.complete) img.addEventListener('load', update, { once: true }); });
    update();
    setTimeout(update, 400);
  }

  function reveal(root) {
    var sec = root.closest('.shopify-section');
    if (sec) sec.classList.remove('hidden');
    root.hidden = false;
    initSlider(root);
  }
  function remove(root) {
    var sec = root.closest('.shopify-section');
    if (sec) sec.remove(); else root.remove();
  }

  /* ---------- same-category products ---------- */
  function loadRelated(root) {
    var type = root.getAttribute('data-type') || '';
    var current = root.getAttribute('data-handle');
    var limit = parseInt(root.getAttribute('data-limit'), 10) || 12;
    var track = root.querySelector('.ai-rs__track');
    if (!type || !track) { remove(root); return; }
    var types = typesFor(type), seen = {}, picked = [];
    seen[current] = true;
    (function nextType(i) {
      if (picked.length >= limit || i >= types.length) {
        if (!picked.length) { remove(root); return; }
        addCards(track, picked.slice(0, limit));
        reveal(root);
        return;
      }
      fetchCards(ROOT + 'collections/types?q=' + encodeURIComponent(types[i]) + '&sort_by=best-selling&section_id=ai-type-feed')
        .then(function (items) {
          items.forEach(function (it) {
            var h = it.getAttribute('data-handle');
            if (!seen[h] && picked.length < limit) { seen[h] = true; picked.push(it); }
          });
          nextType(i + 1);
        });
    })(0);
  }

  /* ---------- recently viewed ---------- */
  function readViewed() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function saveViewed(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX_STORED))); } catch (e) {}
  }
  function loadRecent(root) {
    var current = root.getAttribute('data-handle');
    var limit = parseInt(root.getAttribute('data-limit'), 10) || 12;
    var track = root.querySelector('.ai-rs__track');
    var list = readViewed().filter(function (h) { return h && h !== current; });
    if (current) saveViewed([current].concat(list));
    var show = list.slice(0, limit);
    if (!show.length || !track) { remove(root); return; }
    Promise.all(show.map(function (h) {
      return fetchCards(ROOT + 'products/' + encodeURIComponent(h) + '?section_id=ai-type-feed');
    })).then(function (results) {
      var items = [], missing = [];
      results.forEach(function (r, i) { if (r[0]) items.push(r[0]); else missing.push(show[i]); });
      if (missing.length) saveViewed(readViewed().filter(function (h) { return missing.indexOf(h) < 0; }));
      if (!items.length) { remove(root); return; }
      addCards(track, items);
      reveal(root);
    });
  }

  function boot() {
    document.querySelectorAll('[data-ai-related]').forEach(function (el) {
      if (el.getAttribute('data-ai-done')) return; el.setAttribute('data-ai-done', '1'); loadRelated(el);
    });
    document.querySelectorAll('[data-ai-recent]').forEach(function (el) {
      if (el.getAttribute('data-ai-done')) return; el.setAttribute('data-ai-done', '1'); loadRecent(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
